import segmentsReducer from "./reducer";
import saga from "./saga";

export default function segmentsModule() {
  return {
    id: "segmentsReducer",
    reducerMap: {
      segmentsReducer
    },
    sagas: [saga],
    retained: true
  };
}
